<template>
    <div
        class="flex flex-col content-center p-3 m-auto text-center"
        @click="$emit('gallery', photo.id)"
    >
        <img
            class="photo ui image"
            :id="'card_' + photo.id"
            :src="photoSrc"
        >
        <span>
            {{ photo.created_at | prettydate}}
        </span>
    </div>
</template>
<script type="text/javascript">
export default {
    props: {
        photo: {
            required: true
        }
    },
    data() {
        return {
            photoSrc: null,
            fullPhoto: null
        };
    },
    mounted() {
        this.$store
            .dispatch("photo/THUMB", this.photo.id)
            .then(data => (this.photoSrc = data));
    }
};
</script>
